/** @format */

import { FacilityGroup } from 'sletat-api-services/lib/sletat/models/initial-state/page-models/hotel';
import { HotelBasicFacilityGroups } from '../hotel-page/models/hotel-info';

const beachId = 19;

const beachType = 20;
export function mergeBeachLineWithBeach<T extends FacilityGroup>(
    input: T[] | null
) {
    if (!input) return null;
    const copyInput = input?.map((e) => ({ ...e }));
    const indexBeachLine = copyInput?.findIndex(
        (e) => e.id === HotelBasicFacilityGroups.BeachLine
    );

    const indexBeach = copyInput?.findIndex((e) => e.id === beachId);
    const indexBeachType = copyInput?.findIndex((e) => e.id === beachType);
    if (indexBeach !== -1) {
        copyInput[indexBeach].facilities = [
            ...(copyInput[indexBeach] && copyInput[indexBeach].facilities),
            ...((copyInput[indexBeachLine] &&
                indexBeachLine !== -1 &&
                copyInput[indexBeachLine].facilities) ||
                []),
            ...((copyInput[indexBeachType] &&
                indexBeachType !== -1 &&
                copyInput[indexBeachType].facilities) ||
                []),
        ];
        return copyInput.filter(
            (e) =>
                ![beachType, HotelBasicFacilityGroups.BeachLine].includes(e.id)
        );
    }
    return input;
}
